import { render, staticRenderFns } from "./dashboard-module.vue?vue&type=template&id=159cd3c2&scoped=true&"
import script from "./dashboard-module.ts?vue&type=script&lang=ts&"
export * from "./dashboard-module.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-module.scss?vue&type=style&index=0&id=159cd3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159cd3c2",
  null
  
)

export default component.exports